import aes from "aes-js";
import forge from "node-forge";

import { VPL_ENCRYPTION_KEY, VPL_ENCODED_IV } from "../config/environment";

const key = aes.utils.hex.toBytes(VPL_ENCRYPTION_KEY);
const iv = aes.utils.hex.toBytes(VPL_ENCODED_IV);

const bytesToBase64 = (bytes) => {
  return Buffer.from(bytes).toString("base64");
};

const base64ToBytes = (base64) => {
  return Uint8Array.from(Buffer.from(base64, "base64"));
};

export const encryptData = (plainText) => {
  const textBytes = aes.utils.utf8.toBytes(plainText);
  const aesCbc = new aes.ModeOfOperation.cbc(key, iv);
  const paddedText = aes.padding.pkcs7.pad(textBytes);
  const encryptedBytes = aesCbc.encrypt(paddedText);
  return bytesToBase64(encryptedBytes);
};

export const decryptData = (cipherText) => {
  const encryptedBytes = base64ToBytes(cipherText);
  const aesCbc = new aes.ModeOfOperation.cbc(key, iv);
  const decryptedBytes = aesCbc.decrypt(encryptedBytes);
  const unPaddedBytes = aes.padding.pkcs7.strip(decryptedBytes);
  return aes.utils.utf8.fromBytes(unPaddedBytes);
};

export const encryptRSAData = (data) => {
  const publicKey = forge.pki.publicKeyFromPem(
    process.env.NEXT_PUBLIC_RSA_PUBLIC_KEY
  );

  const encryptedData = publicKey.encrypt(data, "RSA-OAEP", {
    md: forge.md.sha256.create(),
  });

  return forge.util.encode64(encryptedData);
};
